var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpRow",
    [
      _c(
        "ItpCol",
        { attrs: { w: "5" } },
        [
          _c(
            "BListGroup",
            { staticClass: "list-group-alt-1", attrs: { flush: "" } },
            [
              _c(
                "ItpLabeledListGroupItem",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm._f("pgettext")("Own company", "Invoice"),
                    labelCols: _vm.leftColumnLabelCols
                  }
                },
                [
                  _c("UcCompanyMiniCard", {
                    attrs: {
                      role: "own",
                      item: _vm.invoice.company,
                      "no-icon": ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.invoice.company
                    ? _c("UcInvoicePartyPanel", {
                        attrs: { item: _vm.invoice.company }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpLabeledListGroupItem",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm._f("pgettext")("Partner", "Invoice"),
                    labelCols: _vm.leftColumnLabelCols
                  }
                },
                [
                  _c("UcCompanyMiniCard", {
                    attrs: {
                      role: "partner",
                      item: _vm.invoice.client,
                      "no-icon": ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.invoice.client
                    ? _c("UcInvoicePartyPanel", {
                        attrs: { item: _vm.invoice.client }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.invoice.invoice_date
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Invoice date", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("date")(_vm.invoice.invoice_date)) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.fulfillment_date
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")(
                          "Fulfillment date",
                          "Invoice"
                        ),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("date")(_vm.invoice.fulfillment_date)
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.invoice.meta &&
                      _vm.invoice.meta.calculated_fulfillment_date &&
                      _vm.invoice.meta.calculated_fulfillment_date !=
                        _vm.invoice.fulfillment_date
                        ? _c(
                            "span",
                            { staticClass: "itp-badge badge-warning ml-2" },
                            [
                              _c("icon", {
                                attrs: { icon: "ant-design:warning-filled" }
                              }),
                              _vm._v(
                                "\n" +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.invoice.meta
                                        .calculated_fulfillment_date
                                    )
                                  ) +
                                  "\n\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.billing_period &&
              (_vm.invoice.billing_period.start ||
                _vm.invoice.billing_period.end)
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Billing period", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("DIV", { staticClass: "text-nowrap" }, [
                        _vm.invoice.billing_period.start
                          ? _c("strong", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.invoice.billing_period.start
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.invoice.billing_period.start
                          ? _c("strong", [
                              _vm._v("\n            n/a\n          ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("strong", [_vm._v("\n            -\n          ")]),
                        _vm._v(" "),
                        _vm.invoice.billing_period.end
                          ? _c("strong", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.invoice.billing_period.end
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.invoice.billing_period.end
                          ? _c("strong", [
                              _vm._v("\n            n/a\n          ")
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.accounting_date
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Accounting Date", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("date")(_vm.invoice.accounting_date)
                            ) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.vat_period && _vm.invoice.vat_period.name
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("VAT Period", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.invoice.vat_period.name) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.email_template && _vm.invoice.email_template.name
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Email Template", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.invoice.email_template.name) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.reference_number
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")(
                          "Reference Number",
                          "Invoice"
                        ),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.invoice.reference_number) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.order_number
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Order Number", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.invoice.order_number) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.file_number
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("File Number", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.invoice.file_number) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "BListGroup",
                { staticClass: "list-group-alt-1 mb-2", attrs: { flush: "" } },
                [
                  _c(
                    "ItpLabeledListGroupItem",
                    {
                      attrs: {
                        label: _vm._f("pgettext")("Notes", "Invoice"),
                        labelCols: _vm.leftColumnLabelCols
                      }
                    },
                    [
                      _c("MultilineNotes", {
                        attrs: {
                          value: _vm.invoice.notes,
                          editable: !_vm.invoice.locked
                        },
                        on: {
                          save: function($event) {
                            return _vm.evh_388211655357085_save($event, {})
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.invoice.internal_notes
                ? _c(
                    "BListGroup",
                    { staticClass: "list-group-alt-1", attrs: { flush: "" } },
                    [
                      _c(
                        "ItpLabeledListGroupItem",
                        {
                          attrs: {
                            label: _vm._f("pgettext")(
                              "Internal Notes",
                              "Invoice"
                            ),
                            labelCols: _vm.leftColumnLabelCols
                          }
                        },
                        [
                          _c("ItpText", {
                            attrs: { text: _vm.invoice.internal_notes, pre: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpCol",
        { attrs: { w: "7" } },
        [
          _c(
            "BListGroup",
            { staticClass: "list-group-alt-1", attrs: { flush: "" } },
            [
              _vm.invoice.currency
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Currency", "Invoice"),
                        strong: ""
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.invoice.currency) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.exchange_rate && _vm.invoice.exchange_rate != 1
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Exchange rate", "Invoice"),
                        strong: ""
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("number")(_vm.invoice.exchange_rate)
                            ) +
                            "\n"
                        ),
                        _vm.invoice.exchange_rate_bank
                          ? _c("span", [
                              _vm._v(
                                "\n  · " +
                                  _vm._s(_vm.invoice.exchange_rate_bank) +
                                  "\n"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.invoice.exchange_rate_date
                          ? _c("span", [
                              _vm._v(
                                "\n  (" +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.invoice.exchange_rate_date
                                    )
                                  ) +
                                  ")\n"
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.due_date
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Due date", "Invoice")
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("date")(_vm.invoice.due_date)) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.payment_method
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Payment Method", "Invoice")
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("pgettext")(
                                _vm.invoice.payment_method,
                                "PaymentMethod",
                                "Sentence"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.expense_type
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Expense Type", "Invoice")
                      }
                    },
                    [
                      _c("ItpText", { attrs: { strong: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("pgettext")(
                                _vm.invoice.expense_type,
                                "ExpenseType",
                                "Sentence"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.register_entries.data &&
              _vm.invoice.register_entries.data.length
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Register entries", "Invoice")
                      }
                    },
                    _vm._l(_vm.invoice.register_entries.data, function(entry) {
                      return _c("UcRegisterEntryMiniCard", {
                        key: entry.id,
                        attrs: { item: entry, "no-icon": "" }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ItpLabeledListGroupItem",
                {
                  staticClass: "mt-2 mb-2",
                  attrs: { label: _vm._f("pgettext")("References", "Invoice") }
                },
                [
                  _c("UcInvoiceReferences", {
                    attrs: { invoice: _vm.invoice, reload: _vm.lastLoaded },
                    on: {
                      reload: function($event) {
                        return _vm.evh_4152404563918957_reload($event, {})
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpLabeledListGroupItem",
                {
                  staticClass: "mt-2 mb-2",
                  attrs: { label: _vm._f("pgettext")("Attachments", "Invoice") }
                },
                [
                  _c("UcAttachmentsPanel", {
                    attrs: {
                      parent_id: _vm.invoice.id,
                      parent: _vm.invoice,
                      readonly: _vm.invoice.isReadonly,
                      reload: _vm.lastLoaded
                    },
                    on: {
                      reload: function($event) {
                        return _vm.evh_3855552110905499_reload($event, {})
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.invoice.totals
                ? _c(
                    "ItpLabeledListGroupItem",
                    {
                      staticClass: "mt-2 mb-2",
                      attrs: {
                        label: _vm._f("pgettext")("Payments", "Invoice")
                      }
                    },
                    [
                      _c("UcInvoicePayments", {
                        attrs: { invoice: _vm.invoice, reload: _vm.lastLoaded },
                        on: {
                          reload: function($event) {
                            return _vm.evh_4039445435535707_reload($event, {})
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }